import { VStack } from '@cbhq/cds-web/layout';
import { Link, TextBody, TextDisplay3 } from '@cbhq/cds-web/typography';

import { CLOUD_SALES } from ':cloud/utils/links';
import { Layout } from ':cloud/widgets/layout';
import { MAIN_CONTAINER_MIN_WIDTH } from ':cloud/widgets/product/constants';
import NetworkTable from ':cloud/widgets/staking/NetworkTable';

export function StakingCommunity() {
  return (
    <Layout enableMaxWidth={false}>
      <Layout.MainContainer minWidth={MAIN_CONTAINER_MIN_WIDTH} spacingHorizontal={0} fullWidth>
        <VStack spacingHorizontal={7} gap={6} borderedBottom>
          <TextDisplay3 as="h1">Networks</TextDisplay3>
          <VStack>
            <TextBody as="p" color="foregroundMuted" spacingTop={1} spacingBottom={2}>
              View our list of community validators you can directly stake to using the validator
              address or our Staking API.
            </TextBody>
            <TextBody color="foregroundMuted" as="p" spacingBottom={4}>
              Looking for enterprise sales?{' '}
              <Link href={CLOUD_SALES} openInNewWindow>
                Contact us
              </Link>
            </TextBody>
          </VStack>
        </VStack>
        <NetworkTable />
      </Layout.MainContainer>
    </Layout>
  );
}
